import { useState, useEffect, useRef } from "react";

const TypingEffect = ({
  text,
  type,
  speed = 100,
  isNotEffect = false,
  className,
  onComplete,
}) => {
  const [displayedText, setDisplayedText] = useState("");
  const [index, setIndex] = useState(0);

  // Store onComplete in useRef to prevent unnecessary re-renders
  const onCompleteRef = useRef(onComplete);

  useEffect(() => {
    onCompleteRef.current = onComplete;
  }, [onComplete]); // Update ref whenever onComplete changes

  useEffect(() => {
    if (isNotEffect) {
      setDisplayedText(text);
      if (onCompleteRef.current) onCompleteRef.current(); // Call stored function
      return;
    }

    if (index < text.length) {
      const timeout = setTimeout(() => {
        setDisplayedText((prev) => prev + text[index]); // Append one character
        setIndex((prev) => prev + 1);
      }, speed);

      return () => clearTimeout(timeout);
    } else {
      if (onCompleteRef.current) onCompleteRef.current(); // Call stored function after typing finishes
    }
  }, [index, speed, text, isNotEffect]); // Kept dependencies minimal to avoid infinite re-renders

  return (
    <>
      {isNotEffect ? (
        <p className={className}>{displayedText}</p>
      ) : (
        <p
          className={className}
          dangerouslySetInnerHTML={{ __html: displayedText }}
        />
      )}
    </>
  );
};

export default TypingEffect;
